goog.provide("shadow.js.shim.module$react_use$lib$useEvent");
goog.provide("module$shadow_js_shim_module$react_use$lib$useEvent");
shadow.js.shim.module$react_use$lib$useEvent = shadow.js.nativeProvides["react-use/lib/useEvent"] = shadow$bridge("react-use/lib/useEvent");
module$shadow_js_shim_module$react_use$lib$useEvent.default = shadow.js.shim.module$react_use$lib$useEvent;
